// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success_box[data-v-cd4d556a]{height:calc(100vh - 160px);display:flex;flex-direction:column;align-items:center;justify-content:center}.success_box>span[data-v-cd4d556a]{margin-top:24px;color:#333;font-size:18px;font-weight:700}", ""]);
// Exports
module.exports = exports;
